"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone, Mail } from "lucide-react";
export default function BookAVehicle() {
  const {
    ref: mainRef,
    isVisible: mainVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="book-a-vehicle" className="dark bg-background text-foreground relative min-h-[70vh] flex items-center justify-center overflow-hidden section-padding px-6">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/metallic_luxury_texture.png)] bg-cover bg-center opacity-5 pointer-events-none" />

      <div ref={mainRef} className={`relative z-10 max-w-2xl mx-auto text-center transition-all duration-[var(--duration-slow)] ${mainVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-8 tracking-tight">
          Reserve Your Luxury Ride
        </h2>

        {}
        <div className="mb-10">
          <Button size="lg" className="glass-effect px-12 py-6 text-lg font-semibold uppercase tracking-wider hover:scale-[1.02] hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] focus-ring">
            <Phone className="size-5" />
            Call to Reserve
          </Button>
        </div>

        {}
        <div className="mb-8 animate-pulse">
          <Link to="tel:323-492-6292" className="inline-flex items-center gap-3 text-2xl md:text-3xl font-display font-bold text-secondary hover:text-secondary-hover transition-colors duration-[var(--duration-fast)] focus-ring rounded-md px-4 py-2">
            <Phone className="size-6" />
            323-492-6292
          </Link>
        </div>

        {}
        <div className={`transition-opacity duration-[var(--duration-slow)] delay-300 ${mainVisible ? "opacity-100" : "opacity-40"}`}>
          <p className="text-muted-foreground text-sm md:text-base flex items-center justify-center gap-2 font-sans">
            <Mail className="size-4 text-secondary" />
            Or email us at{" "}
            <Link to="mailto:phoenixenterprises@gmail.com" className="text-secondary hover:text-secondary-hover underline underline-offset-4 transition-colors duration-[var(--duration-fast)] focus-ring rounded px-1">
              phoenixenterprises@gmail.com
            </Link>
          </p>
        </div>
      </div>
    </section>;
}